import { CreateSiteResponse } from '../../../utils/Models';
import ax from '../../api/AxiosConfig';

 const createSite = async (data: any): Promise<CreateSiteResponse> => {
  const response = await ax.post('/v1/sites', data);
  return response.data;
};
const addHierarchy = async (data: any): Promise<{data: string}> => {
  const response = await ax.post('/emission/AddHierarchy', data);
  return response.data;
};

const SitesService = {
  addHierarchy,
  createSite
};
export default SitesService;